import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Note } from '../model/note';

interface DeleteNoteParams {
  noteId: string;
}

export const deleteNoteAPI = async ({ noteId }: DeleteNoteParams) => {
  const response = await baseAPI.delete<Note>(`/notes/${noteId}`);
  return response.data;
};

export const useDeleteNote = () => {
  return useMutation({
    mutationFn: (params: DeleteNoteParams) => deleteNoteAPI(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.NOTES],
      });
    },
  });
};
